document.addEventListener('DOMContentLoaded', function() {
    const selectElement = document.querySelector('select.sorting-select');
    const customOptions = document.querySelector('.expanded-sorting-options');
    const customOptionItems = customOptions.querySelectorAll('li');

    customOptionItems.forEach(function(item) {
        item.addEventListener('click', function() {
          const value = this.getAttribute('data-value');
          selectElement.value = value;
          document.querySelector('#FacetFiltersFormMobile').submit();
        });
    });

    selectElement.addEventListener('change', function() {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const selectedValue = selectedOption.value;
        customOptionItems.forEach(function(item) {
            const value = item.getAttribute('data-value');
            if (value === selectedValue) {
                item.classList.add('selected');
            } else {
                item.classList.remove('selected');
            }
        });
    });
});